import { neverHere } from "../tsHelpers";

export const asArray = (): ItineraryStatus[] => [
  ItineraryStatus.Current,
  ItineraryStatus.Draft,
  ItineraryStatus.Old,
];

export const toFriendlyName = (type: ItineraryStatus) => {
  switch (type) {
    case ItineraryStatus.Current:
      return "Current";
    case ItineraryStatus.Draft:
      return "Draft";
    case ItineraryStatus.Old:
      return "Old";
    default:
      neverHere(type);
  }
};
